const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api");

const cleanUrls = (data) => {
  if (!data) return data;
  if (window.location.hostname === "localhost") return data;

  const cleanString = (str) => {
    if (typeof str === "string" && str.includes("http://localhost:5000")) {
      return str.replace(/http:\/\/localhost:5000/g, "");
    }
    return str;
  };

  if (Array.isArray(data)) {
    return data.map(item => cleanUrls(item));
  } else if (typeof data === "object") {
    const cleaned = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        cleaned[key] = cleanUrls(data[key]);
      }
    }
    return cleaned;
  }
  return cleanString(data);
};

const apiFetch = async (url, options) => {
  const response = await fetch(url, options);
  const data = await response.json();
  return cleanUrls(data);
};

export const vehicleService = {
  // Lấy tất cả xe
  getAllVehicles: async () => {
    try {
      return await apiFetch(`${API_BASE_URL}/vehicles`);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      throw error;
    }
  },

  // Lấy chi tiết xe
  getVehicleById: async (id) => {
    try {
      return await apiFetch(`${API_BASE_URL}/vehicles/${id}`);
    } catch (error) {
      console.error("Error fetching vehicle:", error);
      throw error;
    }
  },

  // Lấy media xe theo vehicle_id
  getVehicleMediaByVehicleId: async (vehicleId) => {
    try {
      return await apiFetch(`${API_BASE_URL}/vehicles/${vehicleId}/media`);
    } catch (error) {
      console.error("Error fetching vehicle media:", error);
      throw error;
    }
  },

  // Lấy tất cả variants (cho trang so sánh)
  getAllVariants: async () => {
    try {
      return await apiFetch(`${API_BASE_URL}/vehicles/all-variants`);
    } catch (error) {
      console.error("Error fetching variants:", error);
      throw error;
    }
  },

  // So sánh 2 phiên bản xe (theo variant_id)
  compareVehicles: async (variantId1, variantId2) => {
    try {
      return await apiFetch(
        `${API_BASE_URL}/vehicles/compare?id1=${variantId1}&id2=${variantId2}`
      );
    } catch (error) {
      console.error("Error comparing vehicles:", error);
      throw error;
    }
  },

  // Tìm kiếm xe
  searchVehicles: async (query) => {
    try {
      return await apiFetch(
        `${API_BASE_URL}/vehicles/search?q=${query}`
      );
    } catch (error) {
      console.error("Error searching vehicles:", error);
      throw error;
    }
  },
};

export const bookingService = {
  // Tạo đơn đặt cọc
  createBooking: async (bookingData) => {
    try {
      return await apiFetch(`${API_BASE_URL}/bookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookingData),
      });
    } catch (error) {
      console.error("Error creating booking:", error);
      throw error;
    }
  },

  // Lấy danh sách đơn đặt cọc
  getBookings: async () => {
    try {
      return await apiFetch(`${API_BASE_URL}/bookings`);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      throw error;
    }
  },
};

export const adminService = {
  getSettings: async () => {
    try {
      return await apiFetch(`${API_BASE_URL}/settings`);
    } catch (error) {
      console.error("Error fetching settings:", error);
      throw error;
    }
  },
  saveSettings: async (settingsData) => {
    try {
      return await apiFetch(`${API_BASE_URL}/settings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(settingsData),
      });
    } catch (error) {
      console.error("Error saving settings:", error);
      throw error;
    }
  },
  uploadSettingImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      const response = await fetch(`${API_BASE_URL}/settings/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      const cleaned = cleanUrls(data);
      return `${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${cleaned.url}`;
    } catch (error) {
      console.error("Error uploading setting image:", error);
      throw error;
    }
  }
};
